// @ts-nocheck
import {useCallback, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {BaseButton, BaseModal} from "@/components";
import {getStorage, setStorage} from "@/store/util.store";
import useGetBannerList from "../../../../../hooks/useGetBanners";
import {useAuthStore} from "../../../../../store/useAuth.store";

const SAME_BANNER_INTERVAL = 86400000;
const FIRST_BANNER_SHOW = 6000;
const NEW_BANNER_CHECK = 3600000;
const NEXT_BANNER_SHOW = 300000;

const AppBanners = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentBanner, setCurrentBanner] = useState(null);
  const authStatus = useAuthStore(state => state.authStatus);
  const {data: banners, isLoading} = useGetBannerList();
  const timerRef = useRef(null);

  const {t} = useTranslation();

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const canShowBanner = useCallback(bannerId => {
    const lastShown = getStorage(`banner_${bannerId}_lastShown`);
    if (!lastShown) {
      return true;
    }
    return Date.now() - Number(lastShown) > SAME_BANNER_INTERVAL;
  }, []);

  const findAvailableBanner = useCallback(() => {
    if (!banners || banners.length === 0) {
      return null;
    }
    return banners.find(banner => canShowBanner(banner.id));
  }, [banners, canShowBanner]);

  const showBanner = useCallback(banner => {
    if (!banner) {
      return;
    }

    const img = new Image();
    img.src = `https://images.cdn.raspaygana.com.ve/images/${banner.image_key}`;

    setCurrentBanner(banner);
    setIsModalOpen(true);
    setStorage(`banner_${banner.id}_lastShown`, Date.now().toString());
  }, []);

  const checkAndShowBanner = useCallback(() => {
    const banner = findAvailableBanner();
    if (banner) {
      showBanner(banner);
    } else {
      timerRef.current = setTimeout(checkAndShowBanner, NEW_BANNER_CHECK);
    }
  }, [findAvailableBanner, showBanner]);

  useEffect(() => {
    if (authStatus === "authenticated" && banners) {
      timerRef.current = setTimeout(checkAndShowBanner, FIRST_BANNER_SHOW);
    }

    return () => clearTimeout(timerRef.current);
  }, [authStatus, banners, checkAndShowBanner]);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
    timerRef.current = setTimeout(checkAndShowBanner, NEXT_BANNER_SHOW);
  }, [checkAndShowBanner]);

  if (!authStatus || authStatus !== "authenticated" || !currentBanner) return null;

  return (
    <BaseModal
      open={isModalOpen}
      onClose={handleCancel}
      size="sm"
      closeOnOverlayClick
    >
      {/* Top accent bar */}
      <div className="h-[3px] bg-[linear-gradient(90deg,rgba(250,84,0,1)_0%,rgba(215,50,168,1)_100%)] -mx-6 -mt-5 mb-4 rounded-t-[var(--radius-lg)]" />

      {/* Banner placeholder */}
      <div className="
        w-full aspect-[16/9] rounded-xl mb-4 flex flex-col items-center justify-center gap-2
        bg-[rgba(255,255,255,0.04)] border border-dashed border-[rgba(215,50,168,0.35)]
      ">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="3" y="5" width="18" height="14" rx="2" stroke="rgba(215,50,168,0.6)" strokeWidth="1.5"/>
          <path d="M3 15l4-4 3 3 4-5 4 5" stroke="rgba(215,50,168,0.6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="8.5" cy="9.5" r="1.5" fill="rgba(215,50,168,0.6)"/>
        </svg>
        <span className="text-[11px] font-medium text-[rgba(255,255,255,0.35)] text-center leading-tight px-4">
          Aquí banner popup publicitario
        </span>
      </div>

      {/* Close button */}
      <BaseButton
        variant="primary"
        onClick={handleCancel}
        className="w-full"
      >
        {t("homeDisplayModalClose")}
      </BaseButton>
    </BaseModal>
  );
};

export default AppBanners;
